import { compose, withStateHandlers, lifecycle } from 'recompose';
import { renderNothingIfPropFalsy } from 'utils/recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { pipelineData } from 'reducers/modelPipeline/selectors';
import { theme } from 'reducers/dashboard/selectors';
import { addIntlProps, addProps } from 'utils/recompose';
import formatCurrencyGeneral from 'utils/formatCurrencyGeneral';
import messages from './messages';
import combineSelectors from 'utils/combineSelectors';
import formatPipelineKeys from 'utils/formatPipelineKeys';
import { priceBands } from 'reducers/models/selectors';
import { fetchModelPipeline } from 'reducers/modelPipeline/actions';
import { isInitialState } from 'utils/isInitialState';
import { setObjValuesToFalse } from 'utils/setObjValuesToFalse';

export function componentDidMount() {
  this.props.fetchModelPipeline({ modelId: this.props.modelId });
}

function componentDidUpdate(prevProps) {
  if (prevProps.modelId !== this.props.modelId) {
    this.props.fetchModelPipeline({ modelId: this.props.modelId });
  }
}

export const data = ({ priceBandLabel, priceBands, pipelineData = [] }) => {
  const pbData = [];
  pipelineData
    .sort(function(a, b) {
      return a.code - b.code;
    })
    .forEach(statusSummary => {
      let statusObj = {};
      statusObj['status'] = formatPipelineKeys(statusSummary.description);
      priceBands.forEach(pb => {
        statusObj[`${priceBandLabel}${pb.id}`] =
          statusSummary.quantitiesPerPriceBand[pb.id];
      });
      pbData.push(statusObj);
    });
  return pbData;
};

const mapStateToProps = combineSelectors({
  pipelineData,
  priceBands,
  theme,
});

const mapDispatchToProps = {
  fetchModelPipeline,
};

const initialStateKeys = {
  showPBOne: 'showPBOne',
  showPBTwo: 'showPBTwo',
  showPBThree: 'showPBThree',
  showPBFour: 'showPBFour',
  showPBFive: 'showPBFive',
};

export const initialState = {
  showPBOne: true,
  showPBTwo: true,
  showPBThree: true,
  showPBFour: true,
  showPBFive: true,
};

export const resetFilters = () => () => initialState;

export const togglePBOne = props => () => {
  const { showPBOne } = props;
  if (isInitialState(props)) {
    return setObjValuesToFalse(props, initialStateKeys.showPBOne);
  }
  return { showPBOne: !showPBOne };
};

export const togglePBTwo = props => () => {
  const { showPBTwo } = props;
  if (isInitialState(props)) {
    return setObjValuesToFalse(props, initialStateKeys.showPBTwo);
  }
  return { showPBTwo: !showPBTwo };
};

export const togglePBThree = props => () => {
  const { showPBThree } = props;
  if (isInitialState(props)) {
    return setObjValuesToFalse(props, initialStateKeys.showPBThree);
  }
  return { showPBThree: !showPBThree };
};

export const togglePBFour = props => () => {
  const { showPBFour } = props;
  if (isInitialState(props)) {
    return setObjValuesToFalse(props, initialStateKeys.showPBFour);
  }
  return { showPBFour: !showPBFour };
};

export const togglePBFive = props => () => {
  const { showPBFive } = props;
  if (isInitialState(props)) {
    return setObjValuesToFalse(props, initialStateKeys.showPBFive);
  }
  return { showPBFive: !showPBFive };
};

export const formattedPriceBandSummary = ({
  priceBands,
  currency,
  intl,
  priceBandLabel,
  data,
}) => {
  let priceBandData = {};
  priceBands.forEach(pb => {
    let min = formatCurrencyGeneral(pb.min, currency, intl);
    let max = formatCurrencyGeneral(pb.max, currency, intl);
    let sumAcrossPipeline = data.reduce(
      (sum, status) =>
        status[`PB${pb.id}`] ? (sum += status[`PB${pb.id}`]) : sum,
      0,
    );
    priceBandData[pb.id] = {
      priceBandName: `${priceBandLabel}${pb.id}`,
      priceRange: `${min} - ${max}`,
      sumAcrossPipeline: sumAcrossPipeline,
    };
  });
  return priceBandData;
};

export const priceBandColors = ({ theme }) => theme.charts.pipeline;

export const dataLoaded = ({ data, formattedPriceBandSummary, priceBands }) =>
  Boolean(
    data.length &&
      formattedPriceBandSummary &&
      Object.keys(formattedPriceBandSummary).length &&
      priceBands.length,
  );

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['currency', 'priceBandLabel', 'clearFiltersLabel'],
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({ componentDidMount, componentDidUpdate }),
  withStateHandlers(initialState, {
    togglePBOne,
    togglePBTwo,
    togglePBThree,
    togglePBFour,
    togglePBFive,
    resetFilters,
  }),
  addProps({ data, priceBandColors }),
  addProps({ formattedPriceBandSummary }),
  addProps({ dataLoaded }),
  renderNothingIfPropFalsy('dataLoaded'),
);
